import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=0758df1a&scoped=true&"
import script from "./Carousel.vue?vue&type=script&lang=ts&"
export * from "./Carousel.vue?vue&type=script&lang=ts&"
import style0 from "./Carousel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Carousel.vue?vue&type=style&index=1&id=0758df1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0758df1a",
  null
  
)

export default component.exports